/**
 * 代替えスクロール -シングルトン-
 */
import ResizeObserver from 'resize-observer-polyfill';
import UAParser from 'ua-parser-js';
import URI from 'urijs';
import {TweenMax, Quart} from 'gsap/all';

class scrollManager {
  /**
   * コンストラクタ
   */
  constructor() {
    // OS・ブラウザ判別
    const parser = new UAParser();
    const ua = parser.getResult();

    const u = new URI(location.href);
    const qs = u.query(true);
    const commandScroll = (qs['scroll'] && qs['scroll'] === 'default') ? true : false;

    // クラス名
    this.name = 'scrollManager';
    this.isDisabled = false;
    this.isMobile = false; //pcのみ有効にする
    if (ua.os.name === 'iOS' || ua.os.name === 'Android' || commandScroll) {
      this.isMobile = true;
    }

    this.wrapper = null;
    this.body = null;

    this.bindScroll = null;
    this.animID = null;
    this.tmpInnerHeight = 0; // 高さチェック用
    this.tmpSt = 0; // スクロール位置仮保持
    // 呼び出しプログラム側で、DOM準備完了したらinit()を実行する
  }

  init() {
    //ブラウザリロード時にスクロール位置を残さない
    //history.scrollRestoration = 'manual';
    //IE11,Edge用（用確認）
    //window.scrollTo(0, 0);

    this.body = document.body;

    // セッティング完了まではfixed
    this.fixed(true);

    //PC以外はスルー
    if (!this.isMobile) {
      this.initPC();
    } else {
      // スマホはブラウザのスクロールに任せる
      this.initSP();
    }
  }

  initPC() {
    // DOM設定
    this.wrapper = document.getElementById('c-wrapper');
    this.wrapper.style.position = 'absolute';
    this.wrapper.style.left = 0;
    this.wrapper.style.top = 0;
    this.wrapper.style.backfaceVisibility = 'hidden';
    this.wrapper.style.willChange = 'transform';

    // bodyの高さを初期内部の高さで確保
    //let bodyHeight = this.body.scrollHeight;
    //this.tmpInnerHeight = bodyHeight;

    // リサイズ設定
    this.onResize();
    // オブザーバインスタンスを作成
    this.observer = new ResizeObserver(this.onResizeObserver.bind(this));
    this.observer.observe(this.wrapper);

    // スクロール設定
    this.bindScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.bindScroll, {passive: true});

    // PC用クラスを設定
    document.getElementById('c-pics').className = document.getElementById('c-pics').className + ' c-pics--pc';

    // セッティング完了
    this.fixed(false);
  }

  initSP() {
    this.wrapper = document.getElementById('c-wrapper');

    // スマホ用クラスを設定
    document.getElementById('c-pics').className = document.getElementById('c-pics').className + ' c-pics--sp';

    // セッティング完了
    this.fixed(false);
  }

  /**
   * windowリサイズ時
   * 内部の高さの変更に伴い、bodyの高さ再確保が必要（pageUpdate実行）
   */
  onResize() {
    this.changeBodyHeight(this.wrapper.clientHeight);
  }

  onResizeObserver(entries) {
    this.changeBodyHeight(entries[0].contentRect.height);
  }

  changeBodyHeight(bodyHeight) {
    if (this.tmpInnerHeight !== bodyHeight) {
      this.body.style.height = `${bodyHeight}px`;
      this.tmpInnerHeight = bodyHeight;
    }
  }

  /**
   * windowスクロール時
   * windowスクロール値に伴い、固定配置されたinnerのy座標をeaseing移動
   */
  onScroll() {
    this.animID = requestAnimationFrame(this.scrolling.bind(this));
  }

  scrolling() {
    const toY =  -this.getScrollTop();

    TweenMax.to(this.wrapper, 0.6, {
      force3D: true,
      y: toY,
      delay: 0,
      ease: Quart.easeOut
    });
  }

  /**
   * 画面を固定してスクロールさせない
   */
  fixed(bool) {
    if (bool) {
      this.body.style.overflowX = 'hidden';
      this.body.style.overflowY = 'scroll';
      this.body.style.position = 'fixed';
      this.body.style.height = 'auto';
    } else {
      //this.body.style.overflowX = 'auto';
      this.body.style.overflowX = 'hidden';
      this.body.style.overflowY = 'scroll';
      this.body.style.position = 'relative';
    }
  }

  /**
   * スクロール停止
   */
  xStopScroll() {
    //PC以外はスルー
    if (this.isMobile) {
      this.tmpSt = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;

      this.body.style.overflow = 'hidden';
      this.body.style.position = 'fixed';

      TweenMax.set(this.wrapper, {y: -this.tmpSt});
    } else {
      window.removeEventListener('scroll', this.bindScroll, {passive: true});

      // スクロール処理を止める
      this.isDisabled = true;

      // スクロールTweenキャンセル
      TweenMax.killTweensOf(this.wrapper);

      // スクロール位置を仮保持
      this.tmpSt = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;

      //body innerのスクロールを停止
      this.body.style.overflowX = 'hidden';
      this.body.style.overflowY = 'scroll';
      this.stopScrollTimer = requestAnimationFrame(this.xStopScrollComp.bind(this));
    }
  }

  xStopScrollComp() {
    this.body.style.position = 'fixed';
  }

  /**
   * スクロール開始
   */
  xStartScroll() {
    //PC以外はスルー
    if (this.isMobile) {
      this.body.style.overflowX = 'hidden';
      this.body.style.overflowY = 'scroll';
      this.body.style.position = 'relative';

      TweenMax.set(this.wrapper, {clearProps: 'y'});

      window.scrollTo(0, this.tmpSt);
    } else {
      window.addEventListener('scroll', this.bindScroll, {passive: true});

      //TweenMax.set(this.body,{overflow:"auto"});
      this.body.style.overflowX = 'hidden';
      this.body.style.overflowY = 'scroll';
      this.body.style.position = 'relative';

      this.isDisabled = false;

      //this.pageUpdate();

      //console.log(document.documentElement.scrollTop);
      // 事前スクロール位置に復帰
      //document.documentElement.scrollTop = this.tmpSt;
      window.scrollTo(0, this.tmpSt);
    }
  }

  destroy() {
    if (!this.isMobile) {
      this.observer.disconnect();
      window.removeEventListener('scroll', this.bindScroll, {passive: true});
      cancelAnimationFrame(this.animID);
      TweenMax.killTweensOf(this.wrapper);
    }
  }

  getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }
}

export default new scrollManager();